export const CONFIG_PREFIX_SEPARATOR = ".";
